import { BCRadio } from '@bimser/components';
import { FormItemTypes, IDictionary } from '@bimser/core';
import { JSX } from 'react';
import { IPropertyField } from '../../../../entities/common';
import LabeledInputBase from '../../base/LabeledInputBase';
import { IRadioProperties } from './entities/IRadioProperties';
import { IRadioValueChangedEventArgs } from './entities/IRadioValueChangedEventArgs';

export default class Radio extends LabeledInputBase<boolean> {
	groupName: string;

	constructor() {
		super();
		this.controlType = FormItemTypes.EControlTypes.Radio;
		this.value = false;

		this.subscribe('trigger:OnValueChanged', (value: string) => {
			if (value === 'true') {
				this.triggerValueChanged({ data: true } as any);
			}
		});
	}

	initialize() {
		super.initialize();
		this.__form.subscribe(
			'internalEvent:RadioValueChanged',
			(data: IRadioValueChangedEventArgs) => {
				if (this.groupName === data.groupName && data.controlId !== this.controlId) {
					this.__proxyChanging.value = false;
				}
			}
		);
	}

	__loadProperties(data: IRadioProperties) {
		super.__loadProperties(data);
		this.__proxyChanged.groupName = data.groupName;
	}

	private triggerValueChanged(value) {
		this.__proxyChanging.value = value;

		if (this.groupName) {
			this.__form.emit<IRadioValueChangedEventArgs>('internalEvent:RadioValueChanged', {
				controlId: this.controlId,
				groupName: this.groupName
			});
		}
	}

	__getPropertyFields(): IPropertyField[] {
		const fields = super.__getPropertyFields();
		return [
			...fields,
			{
				name: 'value',
				type: 'boolean',
				common: true
			},
			{
				name: 'groupName',
				type: 'string'
			}
		];
	}

	__getComponentData(): IDictionary<any> {
		return {
			...super.__getComponentData(),
			groupName: this.groupName
		};
	}

	__render(children?: JSX.Element) {
		return super.__render(
			<BCRadio
				tabIndex={this.tabIndex}
				selected={this.value}
				text={this.label.getText()}
				value={this.name}
				onSelectedChange={this.triggerValueChanged.bind(this)}
				disabled={this.__isDisabled() || this.__isReadOnly()}
				style={this.style}
				groupName={this.groupName}
			/>
		);
	}
}
